import { Link, useParams } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { SnapshotDetailSection } from '@/features/reports/snapshot-detail'

/** One frozen snapshot, as an addressable screen of its own. */
export function ReportsSnapshotDetailPage() {
  const { snapshotId } = useParams({ from: '/authenticated/reports/snapshots/$snapshotId' })

  return (
    <>
      <Link
        to="/reports/snapshots"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All snapshots
      </Link>

      <PageHeader title="Snapshot" description="Frozen figures, exactly as they were reported." />

      <SnapshotDetailSection snapshotId={snapshotId} />
    </>
  )
}
